import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  PO_LIST,
  IGP_ADD,
  IGP_LIST,
  IGP_ROW_DATA,
  PO_ITEM_LIST,
  FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  UPLOAD_IMAGE,
  UPLOAD_IGP_IMAGE,
} from "./actionTypes";
import {
  apiError,
  getPOListSuccessful,
  IGPListSuccessful,
  IGPDatasuccessfull,
  getPOItemsListSuccess,
  IGPImageUploadSuccess,
} from "./actions";

import {
  postAdd,
  getList,
  getParamsList,
  postEdit,
  postFormData,
  // postDelete,
} from "../../helpers/Helper";
import swal from "sweetalert";
function* getPOListSaga({ payload }) {
  var data = payload.data;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "" && k !== "no_of_pages" && k !== "currentSort") {
        params[k] = data[k];
      }
    }
  }

  try {
    const response = yield call(
      getParamsList,
      "/purchaseorder/activelist",
      params
    );
    yield put(getPOListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddIgp({ payload: { data, IGPId, history } }) {
  try {
    if (IGPId === "0") {
      const response = yield call(postAdd, "/goodsreceivednote2/", data);
      if (response.status === 201) {
        swal("Your IGP Create Successfully.!", {
          icon: "success",
        });
        history.push("/igpdashboard");
      } else {
        swal("Sorry! Unable to Create IGP. Please Try Again!", {
          icon: "error",
        });
      }
    } else {
      const response = yield call(
        postEdit,
        "/goodsreceivednote2/" + IGPId,
        data
      );

      if (response.status === 200) {
        swal(" Your IGP Edited Successfully.!", {
          icon: "success",
        });
        history.push("/igpdashboard");
      } else {
        swal("Sorry! Unable to edit IGP. Please Try Again!", {
          icon: "error",
        });
      }
    }
  } catch (error) {
    swal("Sorry! Unable to Create IGP. Please Try Again!", {
      icon: "error",
    });
    //yield put(apiError(error));
  }
}
function* IGPImageUpload({ payload: { ImageFile, ImageType } }) {
  try {
    const response = yield call(postFormData, "/system/attachment/", {
      file: ImageFile,
    });

    yield put(IGPImageUploadSuccess(response.data, ImageType));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getImageUpload({ payload: { ImageType, ImageFile, callback } }) {
  try {
    const response = yield call(postFormData, "/system/attachment/", {
      file: ImageFile,
    });
    if (response.status === 201) {
      callback(true, response.data);
    }
  } catch (error) {
    callback(false, false);

    yield put(apiError(error));
  }
}

function* getIGPList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/goodsreceivednote2/list",
      params
    );

    yield put(IGPListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getIGPRowdata({ payload: { IGPId } }) {
  try {
    const response = yield call(getList, "/goodsreceivednote2/" + IGPId, {});
    yield put(IGPDatasuccessfull(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getpoItemsList({ payload: { PoID } }) {
  try {
    const response = yield call(getList, "/purchaseorder/" + PoID, {});
    yield put(getPOItemsListSuccess(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
/**
 * CProduct the class on body
 * @param {*} cssClass
 */
function manageBodyClass(cssClass, action = "toggle") {
  switch (action) {
    case "add":
      if (document.body) document.body.classList.add(cssClass);
      break;
    case "remove":
      if (document.body) document.body.classList.remove(cssClass);
      break;
    default:
      if (document.body) document.body.classList.toggle(cssClass);
      break;
  }

  return true;
}
function* FilterShowRightSidebar() {
  try {
    yield call(manageBodyClass, "filters-right-bar-enabled");
  } catch (error) {}
}
function* FilterHideRightSidebar() {
  try {
    yield call(manageBodyClass, "filters-right-bar-enabled", "remove");
  } catch (error) {}
}

export function* watchgetPOList() {
  yield takeEvery(PO_LIST, getPOListSaga);
}
export function* watchigpAdd() {
  yield takeEvery(IGP_ADD, AddIgp);
}

export function* watchgetIGPList() {
  yield takeEvery(IGP_LIST, getIGPList);
}
export function* watchIGPImageUpload() {
  yield takeEvery(UPLOAD_IGP_IMAGE, IGPImageUpload);
}
export function* watchgetImageUpload() {
  yield takeEvery(UPLOAD_IMAGE, getImageUpload);
}
export function* watchIGPData() {
  yield takeEvery(IGP_ROW_DATA, getIGPRowdata);
}
export function* watchPoitemslistData() {
  yield takeEvery(PO_ITEM_LIST, getpoItemsList);
}

export function* watchFilterShowRightSidebar() {
  yield takeEvery(FILTERS_SHOW_RIGHT_SIDEBAR, FilterShowRightSidebar);
}
export function* watchfilterHideRightSidebarr() {
  yield takeEvery(FILTERS_HIDE_RIGHT_SIDEBAR, FilterHideRightSidebar);
}
function* ingatepassSaga() {
  yield all([
    fork(watchgetPOList),
    fork(watchigpAdd),
    fork(watchgetIGPList),
    fork(watchIGPData),
    fork(watchPoitemslistData),
    fork(watchIGPImageUpload),
    fork(watchgetImageUpload),
    fork(watchFilterShowRightSidebar),
    fork(watchfilterHideRightSidebarr),
  ]);
}

export default ingatepassSaga;
